import { SubNav } from "@/components/SubNav"

/**
 * The change log's two tabs. Retention has a tab of its own rather than a panel
 * on the log, so the log screen stays about the log — and so the setting is
 * somewhere findable on the day it is switched on.
 */
export function ChangeLogSubNav() {
  return (
    <SubNav
      ariaLabel="Change log"
      items={[
        { href: "/admin/change_log", label: "Entries" },
        { href: "/admin/change_log/retention", label: "Retention" },
      ]}
    />
  )
}
